$(function() {
  var swatchImages = $('.product-swatch-inline__image');
  if (swatchImages.length > 0) {
    swatchImages.hover(function() {
      var productId = $(this).data('id');
      var imageElement = $('.product-block__image[data-id="'+productId+'"]');
      var productBlock = $(this).closest('.product-block');
      var titleLink = productBlock.find('.product-block__title-link');
      titleLink.attr('href', imageElement.attr('href'));
      imageElement.siblings().hide();
      imageElement.show();
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const toggleButton = document.querySelector('.toggle-button');
  const additionalContent = document.querySelector('.additional-content');

  if (toggleButton) {
    toggleButton.addEventListener('click', function() {
      if (additionalContent.style.display === 'none' || additionalContent.style.display === '') {
        additionalContent.style.display = 'block';
        toggleButton.textContent = 'Learn More -';
      } else {
        additionalContent.style.display = 'none';
        toggleButton.textContent = 'Learn More +';
      }
    });
  }
});